exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.outside-class[data-v-4111b410] {\n    background-color: #f8f8f8;\n}\n", ""]);

// exports
